import {Link} from '@wandb/components';
import React from 'react';

import {DD_PRIVACY_HIDDEN} from '../../../util/datadog/privacy';
import {formatDownloadUrl} from '../formatDownloadUrl';
import type {FileBrowserFile} from '../types';

type UnknownFilePreviewProps = {
  file: FileBrowserFile;
  onDownload(file: FileBrowserFile): void;
};

export function UnknownFilePreview({
  file,
  onDownload,
}: UnknownFilePreviewProps) {
  return (
    <div className="p-16 border-wb-border rounded-lg border">
      Can't render a preview of this file type,{' '}
      <Link
        data-dd-privacy={DD_PRIVACY_HIDDEN}
        href={formatDownloadUrl(file.url ?? '#', file.name)}
        download={file.name}
        onClick={file ? () => onDownload(file) : undefined}>
        click here
      </Link>{' '}
      to attempt to download.
    </div>
  );
}
